import React, { useState, useEffect, useRef } from 'react';

import './desktop-product-list-style.scss';
import useIntersectionObserver from '@src/hooks/useIntersectionObserver';

import Button from '@src/componentsNew/Buttons/Button';
import Typography from '@src/componentsNew/Typography/Typography';
import Carousel from '@src/componentsNew/Carousel/Carousel';
import TextWithNewlines from '@src/componentsNew/TextWithNewlines';

import DesktopProductListFilter from '@src/componentsNew/Filter/DesktopProductListFilter/DesktopProductListFilter';
import DesktopProductListSortingFilter from '@src/componentsNew/Filter/DesktopProductListFilter/DesktopProductListSortingFilter';
import DesktopProductListSection from '@src/componentsNew/ProductListTemplate/ProductListSection/DesktopProductListSection';

import { ProductListBaseProps } from '@src/componentsNew/ProductListTemplate/type';

const DesktopProductList = ({
  pageTitle,
  images,
  level0SubMenu,
  level1SubMenu,
  showLevel1SubmenuAllButton,
  selectedLevel0SubMenu,
  selectedLevel1SubMenu,
  handleClickLevel0SubMenu,
  handleClickLevel1SubMenu,
  productTotalCount,
  variables,
  setVariables,
  setProductTotalCount,
}: ProductListBaseProps) => {
  const [imageWrapperRef, isImageWrapperRefIntersecting] = useIntersectionObserver<HTMLDivElement>({
    threshold: 0,
    rootMargin: '-65px 0px 0px 0px',
  });

  const hasImages = (typeof images === 'object' && 'url' in images) || (Array.isArray(images) && images.length > 0);
  const shouldBeFixed = hasImages ? imageWrapperRef?.current && !isImageWrapperRefIntersecting : true;

  const fixedAreaRef = useRef<HTMLDivElement>(null);
  const [fixedAreaHeight, setFixedAreaHeight] = useState(0);

  useEffect(() => {
    if (fixedAreaRef.current) {
      setFixedAreaHeight(fixedAreaRef.current.offsetHeight);
    }
  }, [selectedLevel0SubMenu]);

  return (
    <div id="desktop-product-list-template-section-wrapper">
      {/* 이미지 영역 */}
      {hasImages && (
        <div className="image-wrapper" ref={imageWrapperRef}>
          {typeof images === 'object' && 'url' in images ? (
            <img className="image" src={images.url} alt={images.alt ?? ''} />
          ) : (
            <Carousel
              customSetting={{
                dots: false,
                infinite: true,
                centerMode: true,
                centerPadding: '0',
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 2000,
                slidesToShow: 1,
                slidesToScroll: 1,
                className: 'image-slider',
              }}
            >
              {images.map((item) => (
                <img key={item.url} className="image" src={item.url} alt={item.alt ?? ''} />
              ))}
            </Carousel>
          )}
        </div>
      )}

      {/* Sort 및 타이틀 */}
      <div className="submenu-section-wrapper" ref={fixedAreaRef}>
        <div className="submenu-content-area">
          <div className="title-area">
            <div className="title-wrapper">
              <Typography variant="h6" component="h6">
                {pageTitle}
              </Typography>
              {level0SubMenu?.length ? (
                <>
                  <Typography variant="h6" component="h6">
                    /
                  </Typography>
                  <Typography
                    variant="h6"
                    component="h6"
                    onClick={(e) => handleClickLevel0SubMenu(e, level0SubMenu[0])}
                  >
                    {level0SubMenu[0]?.name}
                  </Typography>
                </>
              ) : null}
            </div>

            {productTotalCount > 0 ? (
              <div className="sorting-filter-area">
                <Typography
                  variant="body1"
                  component="span"
                  style={{ color: '#666666' }}
                >{`${productTotalCount} Items`}</Typography>

                <DesktopProductListSortingFilter variables={variables} setVariables={setVariables} />
              </div>
            ) : null}
          </div>

          {/* level 0 */}
          {/*{level0SubMenu?.length ? (*/}
          {/*  <div className="submenu-area">*/}
          {/*    {level0SubMenu?.map((level0, idx) => (*/}
          {/*      <Button*/}
          {/*        key={idx}*/}
          {/*        size="medium"*/}
          {/*        cName={`${selectedLevel0SubMenu?.id === level0?.id ? 'selected' : ''}`}*/}
          {/*        onClick={(e: React.MouseEvent) => handleClickLevel0SubMenu(e, level0)}*/}
          {/*      >*/}
          {/*        {level0?.name}*/}
          {/*      </Button>*/}
          {/*    ))}*/}
          {/*  </div>*/}
          {/*) : null}*/}

          {/* level 1 */}
          {showLevel1SubmenuAllButton || level1SubMenu?.length ? (
            <div className="submenu-area">
              {showLevel1SubmenuAllButton && (
                <Button
                  size="small"
                  cName={`${!selectedLevel1SubMenu ? 'selected' : ''}`}
                  onClick={(e: React.MouseEvent) => handleClickLevel1SubMenu(e, null)}
                >
                  All
                </Button>
              )}

              {level1SubMenu?.map((level1, idx) => (
                <Button
                  key={idx}
                  size="small"
                  cName={`${selectedLevel1SubMenu?.id === level1?.id ? 'selected' : ''}`}
                  onClick={(e: React.MouseEvent) => handleClickLevel1SubMenu(e, level1)}
                >
                  {level1?.name}
                </Button>
              ))}
            </div>
          ) : null}
        </div>
      </div>

      <div className="product-list-section-wrapper">
        {/* Header height + padding + fixedAreaHeight */}
        <div className={`filter-area ${shouldBeFixed ? 'fixed' : ''}`} style={{ top: `${fixedAreaHeight + 81}px` }}>
          <DesktopProductListFilter variables={variables} setVariables={setVariables} />
        </div>

        <div className={`products-area ${productTotalCount === 0 ? 'no-product' : ''}`}>
          <DesktopProductListSection variables={variables} setProductTotalCount={setProductTotalCount} />
        </div>
      </div>
    </div>
  );
};

export default DesktopProductList;
